export default async function useCurrentRoute() {
  let { default: router } = await import(
    /* webpackChunkName "main" */ '@/router'
  )
  // @ts-ignore
  return router.currentRoute
}
